import { Icon, type IconName } from "../components/Icon";
import { MarkdownSummary } from "../components/MarkdownText";
import { whenWords } from "./words";

export function WorkRow({ title, detail, label, action, href, icon = "content", tone = "neutral", agent, when }: {
  title: string; detail?: string; label: string; action: string; href: string; icon?: IconName;
  tone?: "neutral" | "active" | "waiting" | "bad" | "good"; agent?: string; when?: number | null;
}) {
  return <article className="work-row" data-tone={tone}>
    <Icon name={icon} size={21} className="work-type" />
    <div className="work-row-copy">
      <div className="work-row-meta">{agent ? <span>{agent}</span> : null}<span className="work-state">{label}</span>{when ? <span>{whenWords(when)}</span> : null}</div>
      <h3 data-quoted="true"><MarkdownSummary text={title} /></h3>
      {detail ? <p>{detail}</p> : null}
      <a className="work-primary-action" href={href}>{action}<Icon name="arrow" size={16} /></a>
    </div>
  </article>;
}
